import userTypeMixin from "@/helpers/Mixins/UserTypeMixin.js";
import {
  DateHelper,
  StringHelper,
} from "@bryntum/schedulerpro";

export default {
  name: "SchedulerRenderMixin",
  mixins: [userTypeMixin],
  
  data() {
    return {  };
  },
  
  methods: {
    renderWeekLabel(obj) {
      return `${this.$t('servicesystem.common_objects.commonterms.week')} ${DateHelper.format(obj, 'YYYY')}`;
    },

    renderDayLabel(headerContext, includeYear = false) {
      const rawDate = headerContext?.startDate ?? headerContext?.date ?? headerContext;
      const parsedDate = rawDate instanceof Date ? rawDate : new Date(rawDate);
      if (!(parsedDate instanceof Date) || Number.isNaN(parsedDate.getTime())) {
        return '';
      }
      const locale = this.$i18n?.locale || 'en-US';
      const formatOptions = includeYear
        ? { weekday: 'long', day: 'numeric', month: 'short', year: 'numeric' }
        : { weekday: 'short', day: 'numeric', month: 'short' };
      const formatted = new Intl.DateTimeFormat(locale, formatOptions).format(parsedDate);
      return formatted ? formatted.charAt(0).toUpperCase() + formatted.slice(1) : formatted;
    },

    renderGroup({ size, /*count,*/ groupRowFor }) {
      size.height = 28;
      var name = '';
      if (this.UserGroupBy == 'type') {
        name = this.getUserTypeName(groupRowFor, true);
      }
      else if (this.UserGroupBy == 'departmentId') {
        name = this.getDepartmentName(groupRowFor);
      }
      return {
        style: 'font-size: 12px; text-transform: none; margin-left: 10px; margin-top: 6px; opacity: 0;',
        html: name //+ ' (' + count + ')'
      };
    },

    renderEventContextMenuExtraItems({ eventRecord, items }) { //conditional items shown when right clicking event
      var openJob = (id, newTab) => this.openJob(id, newTab);
      if (eventRecord.jobId) { //only events with job Id can be opened as jobs
        items.openItem = {
          icon: 'b-fa-arrow-right',
          text: this.$t('servicesystem.common_objects.commonterms.open'),
          weight: 120,
          onItem({ eventRecord }) { openJob(eventRecord.jobId); }
        };
        items.openNewItem = {
          icon: 'b-fa-arrow-up-right-from-square',
          text: this.$t('servicesystem.common_objects.document.open_in_new_tab'),
          weight: 130,
          onItem({ eventRecord }) { openJob(eventRecord.jobId, true); }
        };
      }
      if (!eventRecord.loading) { //dont allow edit or delete while a backend operation on that event is loading
        var openDialog = (e) => { return this.openEventDialog(e) };
        if (!eventRecord.id.includes("_generatedModelClass_")) { //prevent dialog on events that are not from backend
          items.editEvent = {
            icon: 'b-fa-pencil',
            text: this.$t('servicesystem.text.edit'),
            weight: 110,
            onItem(e) { openDialog(e); }
          };
          items.duplicateEvent = {
            icon: 'b-fa-copy',
            text: this.$t('servicesystem.common_objects.commonterms.copy'),
            weight: 115,
            onItem(e) {
              openDialog({ ...e, duplicate: true });
            }
          };
        }
        var callDeleteAppointment = (obj) => { return this.deleteAppointmentSafe(obj); };
        items.deleteEvent = {
          icon: 'b-fa-trash',
          text: this.$t('servicesystem.common_objects.commonterms.delete'),
          weight: 150,
          onItem(obj) { callDeleteAppointment(obj); }
        };
      }
    },

    renderEvent({ eventRecord, renderData }) {
      var title = StringHelper.encodeHtml(eventRecord.name);
      var subtitle = "";
      //participants single element   StringHelper.encodeHtml(eventRecord.resources.map(resource => resource.name)),
      //participants multi element  eventRecord.resources.map(resource => ({ html: resource.name, })),
      if (eventRecord.loading) {
        renderData.cls += 'eventloading';
      }
      if (eventRecord.jobId) {
        renderData.eventColor = this.statuscolor(eventRecord.jobStatusId);
        subtitle = StringHelper.encodeHtml(this.addressDtoToString(eventRecord.address));
      }
      else { //diff style for abscence
        renderData.eventStyle = 'colored';
        renderData.eventColor = 'black';

        let Difference_In_Time = eventRecord.endDate.getTime() - eventRecord.startDate.getTime();
        let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
        var format = Difference_In_Days ? "ddd D. MMM" : "HH:mm"; //show time if duration less than a day, else show the dates
        subtitle = `${DateHelper.format(eventRecord.startDate, format)} - ${DateHelper.format(eventRecord.endDate, format)}`;
      }
      return {
        className: 'assigned',
        children: [
          { style: 'font-size: 12px', html: title },
          { style: 'font-size: 11px', html: subtitle },
        ]
      };
    },

    getDepartmentName(id) {
      var result = this.Departments.find(x => x.Id == id);
      return result?.Name ?? 'No department'
    },
  },

  computed: {
    Departments() {
      return this.$store.getters["plannerstore/Departments"];
    },

    UserGroupBy() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerUserGroupBy");
    },
  },
};